import toMap from "~/misc/toMap";

export const POSTTRUCKSHOWTYPE = toMap([
  "GUID_NOPOST",
  "GUID_NOVERIFY",
  "DETAIL_CREATE",
  "DETAIL_EDIT",
  "DETAIL_COPY",
  "LIST",
  "DETAIL_LOADALERT"
]);

export const LOADSIZE = ["FTL", "LTL", "FTL+LTL"];

export const LOADSIZEPOSTDATA = {
  FTL: "full",
  LTL: "partial",
  "FTL+LTL": "Any",
};

export const LOADSIZESHOW = {
  full: "FTL",
  partial: "LTL",
  any: "FTL+LTL",
};

export const FREQUENCY = {
  "One Time": "fix_date",
  "Recurring Daily": "every_day",
  "Recurring Weekly": "every_week",
  "Recurring Monthly": "every_month",
  fix_date: "One Time",
  every_day: "Recurring Daily",
  every_week: "Recurring Weekly",
  every_month: "Recurring Monthly",
};

export const LISTFREQUENCYSHOW = {
  fix_date: "",
  every_day: "Everyday",
  every_week: "Every",
  every_month: "Monthly",
};

export const FREQUENCYPES = [
  "One Time",
  "Recurring Daily",
  "Recurring Weekly",
  "Recurring Monthly",
];

export const WEIGHTTYPES = [
  "Any",
  "up to 26,000 lbs",
  "26,001-33,000 lbs",
  "33,001-40,000 lbs",
  "40,001+ lbs",
];

export const WEIGHTPOSTDATA = {
  Any: { weightMax: null, weightMin: null },
  "up to 26,000 lbs": { weightMax: "26000", weightMin: "0" },
  "26,001-33,000 lbs": { weightMax: "33000", weightMin: "26001" },
  "33,001-40,000 lbs": { weightMax: "40000", weightMin: "33001" },
  "40,001+ lbs": { weightMax: +Infinity, weightMin: "40001" },
};

export const CalculateWeightType = (min, max) => {
  min = min === null ? 0 : min;
  max = max === null ? 0 : max;
  switch (`${min}|${max}`) {
    case "0|0":
      return "Any";
    case "0|26000":
      return "up to 26,000 lbs";
    case "26001|33000":
      return "26,001-33,000 lbs";
    case "33001|40000":
      return "33,001-40,000 lbs";
    case "40001|0":
      return "40,001+ lbs";
    default:
      return max;
  }
};

export const WEEKLYPOSTDATA = {
  Sunday: 7,
  Monday: 1,
  Tuesday: 2,
  Wednesday: 3,
  Thursday: 4,
  Friday: 5,
  Saturday: 6,
  7: "Sunday",
  1: "Monday",
  2: "Tuesday",
  3: "Wednesday",
  4: "Thursday",
  5: "Friday",
  6: "Saturday",
};

export const WEEKLYTYPES = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

export const MONTHLYTYPES = Array(31)
  .fill(1)
  .map((item, index) => `${index + 1}`);

export const SHOWLABEL = {
  trailerType: "Trailer Type",
  loadSize: "Load Size",
  length: "Length (FT)",
  weight: "Weight (LBS)",
  rate: "Desired Rate Per Mile",
  frequency: "Frequency",
};

export const FREQUENCYTYPE = toMap(["DAILY", "ONETIME", "WEEKLY", "MONTHLY"]);

export const FORMDATA = {
  origin: "",
  orgDeadHead: "",
  destination: "",
  desDeadHead: "",
  trailerType: ["F"],
  // loadSize: "FTL",
  loadSize: "FTL",
  length: "",
  weight: "Any",
  rate: "",
  frequency: "One Time",
  frequencyDate: {
    "One Time": { from: [], to: [] },
    "Recurring Daily": [],
    "Recurring Weekly": [],
    "Recurring Monthly": [],
  },
};

export const ERRORMESS = {
  empty: "Enter City",
  city: "Wrong City",
};

export const FROMERROR = {
  origin: "",
  destination: "",
  trailerType: "",
  loadSize: "",
  length: "",
  weight: "",
  frequency: "",
};

export const SORTTYPE = toMap(["AGE", "PICKUP", "EQUIPMENT", "DROP_OFF"]);

export const ORDERTYPE = toMap(["ASC", "DESC"]);


export const convertToPosttruck = ({
  equipment,
  pickup,dropoff,
  loadSize,weight,length

}) => {
  if(!dropoff) return {
    equipment,
    pickup,
    loadSize,
    weight,
    length : length > 0 ? length : 0,
    frequencyDate: "Everyday",
    frequency: "Recurring Daily",
    recurring: {
      dates: [],
      type: "every_day"
    }
  }
  return {
    equipment,
    pickup,
    dropoff,
    loadSize,
    weight,
    length : length > 0 ? length : 0,
    frequencyDate: "Everyday",
    frequency: "Recurring Daily",
    recurring: {
      dates: [],
      type: "every_day"
    }

  }
}

export const placeBulider  = ({
  lat, lng, address, deadhead, state, city
}) => {
  return {
    lat, lng, address, deadhead, state, city
  }
}

export const convertToWeightType = (weight) => {
  if(!weight) return [["Any"]];
  const type = Object.entries(WEIGHTPOSTDATA).filter(([type, limit])=> {
    if(weight >limit.weightMin && weight <= limit.weightMax) {
      return true;
    }
    return false;
  })
  return type.length ? type : [["Any"]]
}


// WEBPACK FOOTER //
// ./src/pages/PostTruck/utils.js